<template>
  <div class="amp-body">
    <TheHeader />

    <slot />

    <TheSidebarContainer />

    <!-- .footer - нужен для amp-next-page. -->
    <div class="footer" />

    <component
      :is="'amp-next-page'"
      v-if="nextPages"
    >
      <!-- eslint-disable vue/no-v-text-v-html-on-component -->
      <component
        :is="'script'"
        type="application/json"
        data-amp-keep
        v-html="JSON.stringify(nextPages)"
      >
      </component>
      <!-- eslint-enable vue/no-v-text-v-html-on-component -->
    </component>

    <TheFooterContainer />
    <ConsentAmp />
  </div>
</template>

<script setup lang="ts">
  import TheHeader from '~/components/TheHeader.amp/TheHeader.amp.vue';
  import TheSidebarContainer from '~/containers/TheSidebarContainer.amp.vue';
  import TheFooterContainer from '~/containers/TheFooterContainer.amp.vue';
  import { ARTICLE_IMAGE_SIZES } from '~/constants/imageSizes';
  import { getImagesBySizes } from '@devhacker/shared/utils/image';
  import { isAnyRecipePage } from '~/utils/router';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useAmpAttributes } from '@devhacker/shared/composables/useAmpAttributes';
  import { useAmpCustomElementV2 } from '@devhacker/shared/composables/useAmpCustomElementV2';
  import ConsentAmp from '@devhacker/shared/components/ads/ConsentAmp.vue';

  useAmpAttributes();
  useAmpCustomElementV2('amp-next-page', '1.0');

  const route = useRoute();
  const nuxtApp = useNuxtApp();
  const nextPages = ref([]);
  const isRecipe = ref(isAnyRecipePage(route.name));

  const { data: items } = await useAsyncData(async () => {
    try {
      if (isRecipe.value) {
        const response = await nuxtApp.$recipesApi.fetchHomeRecipes(1, 25);
        return response.items;
      }

      const response = await nuxtApp.$wordpressApi.fetchArticles(route, 1, 40);
      return response.data.items;
    } catch (e) {
      console.error('Error in default.amp.vue:', e);
    }
    return [];
  });

  const pageSlug = getSlugFromUrl(route.fullPath);

  const getImage = (defaultImg: IArticleImg[], img: IArticleImg[] | []) => {
    const cover = getImagesBySizes([ARTICLE_IMAGE_SIZES.L.width], img);
    if (cover.length) {
      return cover[0].url;
    }

    const defaultCover = getImagesBySizes([ARTICLE_IMAGE_SIZES.L.width], defaultImg);
    if (defaultCover.length) {
      return defaultCover[0].url;
    }

    return '';
  };

  if (isRecipe.value) {
    nextPages.value = items.value?.reduce(
      (acc: Array<{ title: string; url: string; image: string }>, article: Recipe) => {
        const slugArticle = `${getSlugFromUrl(article.url)}amp/`;

        if (pageSlug !== slugArticle) {
          acc.push({
            title: article.title,
            url: `${article.url}amp/`,
            image: getImage(article.image.sizes, []),
          });
        }
        return acc;
      },
      [],
    );
  } else {
    nextPages.value = items.value?.reduce(
      (acc: Array<{ title: string; url: string; image: string }>, article: IArticle) => {
        const slugArticle = `${getSlugFromUrl(article.url)}amp/`;

        if (!article.adsToken && pageSlug !== slugArticle && !article.teaserUrl) {
          acc.push({
            title: article.title,
            url: `${article.url}amp/`,
            image: getImage(article.defaultImg, article.img),
          });
        }
        return acc;
      },
      [],
    );
  }
</script>

<style lang="scss" scoped>
  :deep(.amp-next-page-links) {
    display: none;
  }
</style>
